import { singletonHook } from './singletonHook';
import { SingletonHooksContainer } from './components/SingletonHooksContainer';
export { singletonHook, SingletonHooksContainer };
var ReactSingletonHook = {
  singletonHook: singletonHook,
  SingletonHooksContainer: SingletonHooksContainer
};
export default ReactSingletonHook;